var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoWifiSignal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.939,
    height: 32.993,
    viewBox: "0 0 41.939 32.993",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NoWiFi",
    transform: "translate(-991.5 -21.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_18",
    "data-name": "Subtraction 18",
    d: "M20.4,31.993a4,4,0,0,1-3.915-3.17l3.068-4.739a4.043,4.043,0,0,1,.845-.09,4,4,0,0,1,0,8Zm7.071-9.072a1.99,1.99,0,0,1-1.415-.585,7.963,7.963,0,0,0-3.973-2.162l2.273-3.512A11.882,11.882,0,0,1,28.885,19.5a2,2,0,0,1-1.418,3.417Zm5.661-5.659a2,2,0,0,1-1.414-.585,15.9,15.9,0,0,0-5.141-3.447l2.2-3.4a19.884,19.884,0,0,1,5.768,4.02,2,2,0,0,1-1.414,3.413Zm-25.469,0a2,2,0,0,1-1.415-3.412A20.013,20.013,0,0,1,18.7,8.072l-2.99,4.622a16.007,16.007,0,0,0-6.631,3.983A1.986,1.986,0,0,1,7.66,17.261Zm31.126-5.654a1.985,1.985,0,0,1-1.411-.585,23.9,23.9,0,0,0-6.407-4.581L33.16,3.055A28.051,28.051,0,0,1,40.2,8.19a2,2,0,0,1-1.418,3.417ZM2,11.606A2,2,0,0,1,.588,8.19,27.828,27.828,0,0,1,20.4,0,28.653,28.653,0,0,1,23.79.2L21.319,4.019c-.3-.011-.611-.018-.925-.018a23.85,23.85,0,0,0-16.978,7.02A1.992,1.992,0,0,1,2,11.606Z",
    transform: "translate(992 21.504)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1411",
    "data-name": "Line 1411",
    d: "M.727,31a1.754,1.754,0,0,1-.937-.27A1.658,1.658,0,0,1-.723,28.4L18.293-.231a1.756,1.756,0,0,1,2.39-.5A1.658,1.658,0,0,1,21.2,1.6L2.18,30.23A1.739,1.739,0,0,1,.727,31Z",
    transform: "translate(1001.154 22.504)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWifiSignal);
export default __webpack_public_path__ + "static/media/no-wifi-signal.93b3ba60a8bc2adc4fb7c53ed70c4a99.svg";
export { ForwardRef as ReactComponent };